function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { StandardInput, FilledInput, OutlinedInput } from './styles';
var variantComponent = {
  standard: StandardInput,
  filled: FilledInput,
  outlined: OutlinedInput
};
export var Input = /*#__PURE__*/memo(function (props) {
  var variant = props.variant,
      rest = _objectWithoutProperties(props, ["variant"]);

  var InputComponent = variantComponent[variant];
  return /*#__PURE__*/React.createElement(InputComponent, Object.assign({
    disableUnderline: true
  }, rest));
});
Input.propTypes = {
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
};
Input.defaultProps = {
  variant: 'standard'
};
export default Input;